import { render, staticRenderFns } from "./LayoutDefault.vue?vue&type=template&id=0a2f8153&"
import script from "./LayoutDefault.vue?vue&type=script&lang=js&"
export * from "./LayoutDefault.vue?vue&type=script&lang=js&"
import style0 from "./LayoutDefault.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports